/**
 * Espaciador vertical. Altura desde `Tamano` (catálogo `Spacing`) o
 * `CustomPx` si lo pisa. `Direccion='Both'` dobla (gap_anterior + gap_siguiente).
 */

type Direccion = 'Top' | 'Bottom' | 'Both';

type SpacingEntry = {
  Px?: number | null;
};

type Props = {
  Tamano?: SpacingEntry | null;
  CustomPx?: number | null;
  Direccion?: Direccion | null;
};

export const ComponentRevisadasSeparador = ({
  Tamano,
  CustomPx,
  Direccion,
}: Props) => {
  const base =
    typeof CustomPx === 'number' && CustomPx > 0
      ? CustomPx
      : typeof Tamano?.Px === 'number'
        ? Tamano.Px
        : 0;

  if (!base) return null;

  const height = Direccion === 'Both' ? base * 2 : base;

  return <div aria-hidden style={{ height: `${height}px` }} />;
};

ComponentRevisadasSeparador.displayName = 'ComponentRevisadasSeparador';
